import { render, staticRenderFns } from "./TransSrvrsTable.vue?vue&type=template&id=7284f3c9&"
import script from "./TransSrvrsTable.vue?vue&type=script&lang=js&"
export * from "./TransSrvrsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports